import * as actions from './actionTypes'

export function toggleChat() {
  return {
    type: actions.TOGGLE_CHAT
  }
}

export function openChat() {
  return {
    type: actions.OPEN_CHAT
  }
}

export function resetChat() {
  return {
    type: actions.RESET_CHAT
  }
}

export function closeChat() {
  return {
    type: actions.CLOSE_CHAT
  }
}

export function addUserMessage(text, timestamp) {
  return {
    type: actions.ADD_NEW_USER_MESSAGE,
    text,
    timestamp
  }
}

export function addResponseMessage(text, timestamp, isLiveAgent) {
  return {
    type: actions.ADD_NEW_RESPONSE_MESSAGE,
    text,
    timestamp,
    isLiveAgent
  }
}

export function addCarousel(carousel) {
  return {
    type: actions.ADD_CAROUSEL,
    carousel,
  }
}

export function renderCustomComponent(component, props, showAvatar) {
  return {
    type: actions.ADD_COMPONENT_MESSAGE,
    component,
    props,
    showAvatar
  }
}

export function dropMessages() {
  return {
    type: actions.DROP_MESSAGES
  }
}

export function setQuickButtons(buttons) {
  return {
    type: actions.SET_QUICK_BUTTONS,
    buttons
  }
}
export function setDropdownOptions(payload) {
  return {
    type: actions.SET_INPUT_DROPDOWN_OPTIONS,
    payload
  }
}

export function setMenu(payload) {
  return {
    type: actions.SET_MENU,
    payload,
  }
}

export function setToc(payload) {
  return {
    type: actions.SET_TOC,
    payload
  }
}

export function setInputDisabled(payload) {
  return {
    type: actions.SET_INPUT_DISABLED,
    payload,
  }
}
export function setBlink(payload) {
  return {
    type: actions.SET_BLINK,
    payload,
  }
}
export function setBlinkColor(payload) {
  return {
    type: actions.SET_BLINK_COLOR,
    payload,
  }
}
export function setInputDropdownType(payload) {
  return {
    type: actions.SET_INPUT_DROPDOWNTYPE,
    payload,
  }
}

export function setInputDateType(payload) {
  return {
    type: actions.SET_INPUT_DATETYPE,
    payload,
  }
}
export function setIsFetching(payload) {
  return {
    type: actions.SET_IS_FETCHING,
    payload,
  }
}
export function clearInput(payload) {
  return {
    type: actions.CLEAR_INPUT,
    payload
  }
}
export const setTheme = (payload) => ({ type: actions.SET_THEME, payload })

export const setStyles = (payload) => ({ type: actions.SET_STYLES, payload })

export const setSenderPlacholder = (payload) => ({ type: actions.SET_SENDER_PLACEHOLDER, payload })
export const toggleTOC = () => ({ type: actions.TOGGLE_TOC })


// WEBPACK FOOTER //
// ./src/ChatWidget/store/actions/index.js